import type { PlanConfig } from '../services/subscriptionService';

import { isIOSApp } from './platformDetection';

/** A credit costs a few cents at most (e.g. $0.024), so per-credit prices keep up to 4 decimals. */
export const formatCreditPrice = (amount: number, currency: 'USD' | 'INR' | string = 'USD'): string => {
  const isINR = currency === 'INR';
  const formatted = new Intl.NumberFormat(isINR ? 'en-IN' : 'en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(Number.isFinite(amount) ? amount : 0);

  return `${isINR ? '₹' : '$'}${formatted}`;
};

/** Currency a top-up price is shown in: the iOS app always sells in USD through Apple. */
export const topupDisplayCurrency = (currency: string): string => (isIOSApp() ? 'USD' : currency);

/** The plan's top-up price per credit in the shown currency (the Apple price in the iOS app). */
export const planTopupRate = (plan: PlanConfig | undefined, currency: string): number | null => {
  if (!plan || plan.topups_allowed === false) return null;
  if (isIOSApp()) return plan.topup_price_per_credit_apple ?? plan.topup_price_per_credit ?? null;

  return (currency === 'INR' ? plan.topup_price_per_credit_inr : null) ?? plan.topup_price_per_credit ?? null;
};
